import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { ACTIVE_SKIN } from './skins';

// Vertical reskin proof (E3.2): stamp the active skin on <html> so the CSS color tokens re-theme
// the whole shell. No-op for the default camp skin — the production experience is untouched.
if (ACTIVE_SKIN.id !== 'camp') document.documentElement.dataset.skin = ACTIVE_SKIN.id;

const root = createRoot(document.getElementById('root')!);

// `/i/:token` is the Ledger app's public (auth-free) customer invoice view. It's
// lazy-loaded so its styles never touch the platform shell on normal paths.
if (window.location.pathname.startsWith('/i/')) {
  void import('./ledger/PublicInvoiceEntry').then(({ PublicInvoiceEntry }) => {
    root.render(
      <StrictMode>
        <PublicInvoiceEntry />
      </StrictMode>,
    );
  });
} else {
  void import('./auth').then(({ Root }) => {
    root.render(
      <StrictMode>
        <Root />
      </StrictMode>,
    );
  });
}
